import * as _ from 'lodash';

const requestBase = {
  limit: 50,
  offset: 0,
  keyword: "",
  is_asc: 1,
  status: null
}

export const requestArea = {
  web_filter: _.assign({
    module_code: "AM",
  }, requestBase)
}

export const requestBranch = {
  web_filter: _.assign({
    module_code: "BM",
    chain_ids: [0],
    chain_type_ids: [0],
    region_ids:[0],
    city_ids:[0],
    province_ids: [0]
  }, requestBase)
}

export const requestBrand = {
  web_filter: _.assign({
    module_code: "BNM",
  }, requestBase)
}

export const requestCampaign = {
  web_filter: _.assign({
    module_code: "CM",
    end_date: "",
  }, requestBase)
}

export const requestChain = {
  web_filter: _.assign({
    module_code: "CHM",
    chain_type_ids: [0]
  }, requestBase)
}

export const requestChainType = {
  web_filter: _.assign({}, requestBase)
}

export const requestCompany = {
  web_filter: _.assign({
    industry_type_ids: [0],
    module_code: "COM",
  }, requestBase)
}

export const requestCountry = {
  web_filter: _.assign({}, requestBase)
}

export const requestCity = {
  web_filter: _.assign({
    country_ids: [0],
    region_ids: [0],
    province_ids: [0],
  }, requestBase)
}

export const requestCategory = {
  web_filter: _.assign({
    module_code: "CTM",
  }, requestBase)
}

export const requestDistrict = {
  web_filter: _.assign({
    module_code: "DSM",
  }, requestBase)
}

export const requestProvince = {
  web_filter: _.assign({
    country_ids: [0],
    region_ids: [0],
  }, requestBase)
}

export const requestRegion = {
  web_filter: _.assign({
    country_ids: [0],
  }, requestBase)
}

export const requestRole = {
  web_filter: _.assign({
    role_id: localStorage.getItem("userRoleId"),
  }, requestBase)
}

export const requestSku = {
  web_filter: _.assign({
    module_code: "IM",
		category_ids:[0],
    brand_ids:[0],
  }, requestBase)
}

export const requestWebUser = {
  web_filter: _.assign({
    module_code: "WUM",
    is_mapping_module: false,
		role_code: localStorage.getItem("userRole")
  }, requestBase)
}

export const requestCoupon = {
  web_filter: _.assign({
    module_code: "CP",
    campaign: [0],
    distribution: [0],
  }, requestBase)
}

export const requestCustomerRegistrationActivityReport = {
  web_filter: {
    full_name: null,
    filters: {
      campaign_id: 0,
      group_id: [0],
      web_user_id: [0]
    }
  }
}

export const requestCustomerFirstPurchaseReport = {
  web_filter: {
    filters: {
      campaign_id: 0,
      group_filter_id: [0],
      web_user_id: [0]
    },
    full_name: null
  }
}

export const requestCustomerTransactionsReport = {
  web_filter: {
    filters: {
      campaign_id: 0,
      group_filter_id: [0],
      web_user_id: [0]
    },
    full_name: null
  }
}

export const requestPatientRegistrationDetailsReport = {
  web_filter: {
    full_name: null,
    filters: {
      campaign_id: 0,
      start_date: null,
      end_date: null
    }
  }
}

export const requestCampaignQrDownload = {
  web_filter: {
    filters: {
      campaign_id: 0,
      campaign_description: null,
      activation_type: null,
      user_group_id: [0],
      recipient_group_id: [0],
      web_user_id: [0],
      recipient_id: [0],
      folder_grouping_by: null,
      single_pdf: true,
      multiple_pdfs: false,
      module_code: "CQRD"
    },
    full_name: null
  }
}

export const requestDetailedSettlementReport = {
  web_filter: {
    full_name: null,
    filters: {
      start_date: null,
      end_date: null,
      chain_id: null,
      island_group_id: [0],
      region_id: [0],
      province_id: [0],
      city_id: [0],
      campaign_id: [0],
      category_id: [0],
      brand_id: [0],
      sku_id: [0]
    }
  }
}

export const requestPostedTransactionReport = {
  web_filter: {
    full_name: null,
    filters: {
      start_date: null,
      end_date: null,
      campaign_id: [0],
      chain_id: null,
      branch_id: null
    }
  }
}


export const requestMonthlyOtpTransactionReport = {
  web_filter: {
    full_name: null,
    filters: {
      month: null,
      year: null
    }
  }
}

export const requestRecipientAllocationDownload = {
  web_filter: {
    full_name: null,
    filters: {
      distribution_id: null,
      group_filter_id: [0],
      web_user_id: [0]
    }
  }
}

export const requestUserAllocationDownload = {
  web_filter: {
    full_name: null,
    filters: {
      distribution_id: null,
      group_filter_id: [0]
    }
  }
}

export const requestWebModule = {
  web_filter: _.assign({
    filters: {
      module_group: 0
    }
  }, requestBase)
}
